import * as React from 'react'

import { Radio } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import { getCopies } from 'modules/contracts/components/FlowSelectorModal/utils'

import CreateRadioOption from '../RadioOptions/CreateRadioOption'
import FixRadioOption from '../RadioOptions/FixRadioOption'

interface Props {
  showFixOption: boolean
  employeeFullname: string
  value: string
  onChange: (option: React.SetStateAction<string>) => void
  withoutContracts: boolean
}

const ExpiredOrUpcomingModalContent = ({
  employeeFullname,
  value,
  onChange,
  showFixOption,
  withoutContracts,
}: Props) => {
  const copies = getCopies(employeeFullname)
  return (
    <>
      <Radio.Wrap>
        <CreateRadioOption
          title={copies.create}
          value={value}
          onChange={onChange}
          withoutContracts={withoutContracts}
        />
      </Radio.Wrap>
      {showFixOption && (
        <Radio.Wrap>
          <FixRadioOption title={copies.fix} value={value} onChange={onChange} />
        </Radio.Wrap>
      )}
    </>
  )
}

export default observer(ExpiredOrUpcomingModalContent)
